import { getParam } from '../url';
var setCookieFromParam = function setCookieFromParam(pname) {
  var param = getParam(pname);
  if (param) {
    document.cookie = "".concat(pname, "=").concat(param);
  }
};
var getCookie = function getCookie(name) {
  return document.cookie.split('; ').reduce(function (r, v) {
    var parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, null);
};
export { setCookieFromParam, getCookie };